import { UnavailableCode } from '../../../../types';
import { CXoneEventsSubscriptionContext } from '../../subscription-context';

export function mapUnavailableCodes(event: unknown): UnavailableCode[] | null {
  let codesArray: unknown[] = [];

  if (Array.isArray(event)) {
    codesArray = event;
  } else if (event && typeof event === 'object') {
    const eventObj = event as Record<string, unknown>;
    codesArray = (eventObj.outStates ||
      eventObj.OutStates ||
      eventObj.unavailableCodes ||
      eventObj.UnavailableCodes ||
      eventObj.codes ||
      eventObj.data ||
      []) as unknown[];
  }

  if (!Array.isArray(codesArray) || codesArray.length === 0) {
    return null;
  }

  return codesArray.map((item: unknown) => {
    const code = item as {
      outStateId?: string | number;
      OutStateId?: string | number;
      outStateName?: string;
      OutStateName?: string;
      reason?: string;
      isACW?: boolean;
      isAcw?: boolean;
    };
    return {
      outStateId: String(code.outStateId || code.OutStateId || ''),
      outStateName: code.outStateName || code.OutStateName || code.reason || 'Unknown',
      isACW: code.isACW || code.isAcw || false,
    };
  });
}

export function applyUnavailableCodes(
  codes: UnavailableCode[],
  ctx: CXoneEventsSubscriptionContext
): void {
  ctx.unavailableCodesRef.current = codes;
  ctx.setUnavailableCodes(codes);
}
